// https://github.com/petamoriken/float16
import { getFloat16, setFloat16 } from "@petamoriken/float16";

const debugOverride = process.env.DEBUG_OVERRIDE === 'true';
const debug =  (!process.env.AWS_SESSION_TOKEN && false ) || debugOverride;

export const toFP16 = ( decimal: number ): Buffer  => {
    const buffer = new ArrayBuffer(2);
    const view: DataView = new DataView(buffer);
    
    setFloat16(view, 0, decimal)
    debug && console.log('view.buffer', view.buffer)
    const msb = view.getUint8(0)
    const lsb = view.getUint8(1)

    const buf = Buffer.from( [ msb, lsb ] )

    return buf
}

/**
 * @function fromFP16 twoByteFP16 is MSB LSB order
 * @param twoByteFP16 
 * @returns 
 */
export const fromFP16 = ( twoByteFP16: Buffer , LE?:boolean ): number => {

    const buffer = new ArrayBuffer(2);
    const view: DataView = new DataView(buffer);
    const msb = twoByteFP16[0]
    const lsb = twoByteFP16[1]
    
    view.setUint8(0, msb )
    view.setUint8(1, lsb)

    const res =  getFloat16(view, 0, LE); 
    debug && console.log('view.buffer', view.buffer)


    return res
}


